import { t } from "../i18n";
import { CheckCircle2 } from "lucide-react";
import type { ToolEvent } from "@lumen/shared";
import { ToolEventTimestamp } from "./chat/ToolEventTimestamp";

export function AnsweredQuestion({ event }: { event: ToolEvent }) {
  const argumentsValue =
    event.arguments && typeof event.arguments === "object"
      ? (event.arguments as Record<string, unknown>)
      : {};
  const result =
    event.result && typeof event.result === "object"
      ? (event.result as Record<string, unknown>)
      : {};
  const question =
    typeof result.question === "string"
      ? result.question
      : typeof argumentsValue.question === "string"
        ? argumentsValue.question
        : t("Please answer the question");
  const answers = Array.isArray(result.answers)
    ? result.answers.filter(
        (answer): answer is string => typeof answer === "string",
      )
    : [];

  return (
    <div className="overflow-hidden rounded-2xl border border-emerald-200/80 bg-gradient-to-br from-emerald-50 to-white p-4 text-stone-900 shadow-sm dark:border-emerald-900/60 dark:from-emerald-950/30 dark:to-stone-950 dark:text-stone-100">
      <ToolEventTimestamp
        event={event}
        className="mb-2 text-right text-[10px] text-stone-400 tabular-nums"
      />
      <div className="flex items-start gap-3">
        <div className="grid size-9 shrink-0 place-items-center rounded-xl bg-emerald-100 text-emerald-700 dark:bg-emerald-900/60 dark:text-emerald-200">
          <CheckCircle2 size={17} />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-[11px] font-semibold tracking-wider text-emerald-700 uppercase dark:text-emerald-300">
            {t("Question answered")}
          </p>
          <p className="mt-1 text-sm leading-6 font-semibold">{question}</p>
          <div className="mt-3 rounded-xl border border-emerald-200/80 bg-white/70 px-3 py-2.5 dark:border-emerald-900/60 dark:bg-white/[0.04]">
            <p className="text-[11px] font-semibold tracking-wider text-stone-500 uppercase dark:text-stone-400">
              {t("Your answer")}
            </p>
            {answers.length ? (
              <ul className="mt-1 space-y-1 text-sm leading-6">
                {answers.map((answer, index) => (
                  <li key={`${answer}-${index}`} className="break-words">
                    {answer}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="mt-1 text-sm">{t("Answer received")}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
